import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CreateTemplate from '..';
import { MainContext } from '../../../../../../context/MainContext';
import {
  getProjectTemplateById,
  updateProjectTemplate,
} from '../../../../../../services/api/projectTemplates';
import { FORMSATTR, TABLEATTR } from './formItems';

const UpdateDeliveryTemplate = () => {
  const { setLoading } = useContext(MainContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const { templateId } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [templateReaded, setTemplate] = useState(null);

  const finishForm = async (regions, formState, fileName) => {
    const regionIndex = regions.findIndex((reg) => reg.data === 'CIF');
    const region = regions[regionIndex];
    regions.splice(regionIndex, 1);
    const updateToTemplate = {
      id: templateId,
      name: formState.templateName.value,
      supplier: formState.supplier_id.value,
      model: 'delivery',
      createdAt: templateReaded.createdAt,
      pid: templateReaded.pid,
      image: fileName.replace('pdf', 'png'),
      searchableRegion: {
        value: '',
        region: region,
      },
      regions: regions,
      pid: parseInt(id, 10),
    };
    await updateProjectTemplate(updateToTemplate);
    return 'templateUpdated';
  };

  useEffect(() => {
    async function loadTemplate() {
      setLoading(true);
      const loadedTemplate = (await getProjectTemplateById({ id: templateId }))
        .data;
      loadedTemplate.regions.unshift(loadedTemplate.searchableRegion.region);
      setTemplate(loadedTemplate);
      setInitialData({
        form: {
          templateName: loadedTemplate.name,
          supplier_id: loadedTemplate.supplier,
        },
        regions: loadedTemplate.regions,
      });
    }
    loadTemplate();
  }, [setLoading, templateId]);

  return (
    <CreateTemplate
      tableAttr={TABLEATTR}
      formsAttr={FORMSATTR}
      closeForm={finishForm}
      initialData={initialData}
      model="delivery"
      customFinishButton={() => {
        return navigate(`/app/project/${id}/quality/ocr/templates`);
      }}
    />
  );
};

export default UpdateDeliveryTemplate;
